var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$b({
    'cross-sell-rating': _vm.crossSellMode,
    'review-mode': _vm.reviewMode,
    'header-mode': _vm.headerMode,
    'inline': _vm.inline
  })},_vm._l((_vm.stars),function(star,i){return _c('div',{key:i,class:_vm.$b('star', { size: _vm.size })},[_c('div',{class:_vm.$b('empty-star')}),_vm._v(" "),_c('div',{class:_vm.$b('full-star'),style:({ width: ((star * 100) + "%") })})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }